// create a react modal component which accepts a prop of imageSource and displays the image in a modal

import React, { useEffect, useState } from "react";
import "./index.scss";
import { BASE_URL } from "constants/routes";
import Modal from ".";
const ImageModal = (props) => {
  const { show, onHide, imageSource, workflow_id, original_name } = props;

  const [imageLoaded, setImageLoaded] = useState(false);
  const [response, setResponse] = useState();
  const [isPdf, setIsPdf] = useState(false);
  const [downloadUrl, setdownloadUrl] = useState();
const checkisPdf = () => {  
  const pdf = original_name.split('.').pop()
  if(pdf === 'pdf' || pdf === 'PDF'){
    setIsPdf(true)
  }
  else{
    setIsPdf(false)
  }
}

  useEffect(() => {
    async function fetchImage() {
      try {
        const response = await fetch(
          `${BASE_URL}/workflow/viewCommentDocument/${workflow_id}/${imageSource}/${original_name}`
        );
        setdownloadUrl( `${BASE_URL}/workflow/downloadCommentDoc/${workflow_id}/${imageSource}/${original_name}`)
        setResponse(response?.url)
        setImageLoaded(true);
        checkisPdf()
      } catch (error) {
        throw error;
      }
    }

    fetchImage();
  }, [workflow_id, imageSource]);

  return (
    <>
      {show && response && (
        <Modal
          show={show}
          imgSrc={response}
          setShowModal={onHide}
          imageLoaded={imageLoaded}
          isPdf={isPdf}
          downloadUrl={downloadUrl}
        />
      )}
    </>
  );
};

export default ImageModal;
